<app-esqueleto-tableros [filterWidth]="250">
  <div titulo class="encabezadosSeparacion">
    <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ "menu." + dataService.moduleSelect | translate }} </b> </span>
    <span class="w3-text-deep-orange">&bull;</span>
    <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ "menu." + dataService.subModuleSelect | translate }} </span>
  </div>
  <app-filters filtros
    [name]="'filtros.periodo' | translate"
    [array]="periodos"
    [typeFilter]="Filters.PERIOD"
    (eventClick)="yearChange($event)"
    [click]="false"
  ></app-filters>
  <app-filters filtros
    [name]="'filtros.region' | translate"
    [array]="zonas"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="consolidadoZona"
    (eventClick)="zonaChange($event)"
  ></app-filters>
  <app-filters filtros
    [name]="'filtros.agencias' | translate"
    [array]="sucursales"
    [typeFilter]="Filters.SUCURSALES"
    [click]="false"
    [consolidado]="consolidado"
    (eventClick)="agencyChange($event)"
  ></app-filters>
  <div borrador class="borradorZona">
    <div class="w3-button w3-dropdown-click iconoBorrarFiltros"
      matTooltip="{{'tooltips.borrar-filtros'|translate}}" (click)="borrarFiltros()">
      <img src="./../../../../assets/img/eraser.png">
    </div>
  </div>
  <div contenido class="metasContenido">
    @if(!skeleton){
    <div class="tableZone">
      <div class="w3-row filaEncabezadoTabla">
        <div class="w3-titulo-contenidomenuSC tituloEncabezado">
          @if(viewTabla){
            <span class="w3-margin-left-contenido">{{ 'comercial.asosiatividad.metas.encabezado' |translate}}</span>
          }
        </div>
        <div class="icons-container">
          @if(viewTabla){
            <mat-icon class="iconoMen" (click)="modal = true">zoom_out_map</mat-icon>
            <mat-icon class="iconoMen" [matMenuTriggerFor]="menu1">more_vert</mat-icon>
            <mat-menu #menu1="matMenu">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="viewTabla = false">
                <mat-icon class="iconoGris">insert_chart</mat-icon>
                <span>{{'menu.graficas' | translate}}</span>
              </button>
              <mat-divider></mat-divider>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportExcel()">
                <mat-icon class="iconoGris">description</mat-icon>
                <span>{{'acciones.exportar' | translate}}</span>
              </button>
            </mat-menu>
          }
        </div>
      </div>
      @if(viewTabla){
      <div class="w3-row w3-scroll zonaTablaScroll">
        <table class="w3-table borderAllLow">
          <thead>
            <tr class="borderEncTop">
              <th class="stikyColumFillWhite2 borderEncRight borderEncLeft w3-center w3-table-title-white stickyFilaUno" colspan="2"></th>
              <th class="stikyColumFillWhite2 borderEncRight w3-center encGrupoFila1 stickyFilaUno" colspan="3">
                {{perspective1}}</th>
              <th class="stikyColumFillWhite2 borderEncRight w3-center encGrupoFila1 stickyFilaUno" colspan="3">{{perspective2}}</th>
              <th class="stikyColumFillWhite2 borderEncRight w3-center encGrupoFila1 stickyFilaUno" colspan="2">
                {{'comercial.asosiatividad.metas.titulo-encabezado-1' | translate}}
              </th>
            </tr>
            <tr class="borderEncTop">
              <th class="borderEncRight borderEncLeft w3-center encZonaAgencias stikyColumFillWhite2 celdaNombrePl10" colspan="2">
                {{'comercial.asosiatividad.metas.titulo-zona-agencias' | translate}}
              </th>
              @for (enc of encabezados; track $index) {
                @if (enc !== 0) {
                  <th class="borderEncRight w3-center"
                    [ngClass]="{'w3-table-title stikyColum2': enc>=1 && enc<=3 || enc>=7, 'stikyColumFillLow2 w3-table-titleLow': enc>=4 && enc<=6}"
                    >
                    {{enc === 10 ? ('comercial.asosiatividad.metas.titulo-meta-anual-clientes' | translate) : ('comercial.asosiatividad.metas.titulo-'+(enc+1)+'-tabla' | translate)}}
                  </th>
                }
              }
            </tr>
          </thead>
          <tbody>
            @for (zona of zonas; track zona.code) {
              @if (zona.visible) {
                <tr class="w3-table-trtd filaZona">
                  <td class="w3-center borderAllLow">
                    <mat-icon class="iconoMen" (click)="expandirElementos(zona)">{{zona.expandido?'expand_less':'expand_more'}}</mat-icon>
                  </td>
                  <td class="borderAllLow celdaNombrePl10">{{zona.name}}</td>
                  @for (valor of zona.datos; track $index) {
                    <td class="w3-right-align borderAllLow">
                      <div class="marginDer celdaAltura" [ngClass]="getIndicatorClassCol(valor, $index)">
                        {{valor | formaterNumber:decimalesCol($index):',':'.'}}{{$index === 2 || $index === 5 || $index === 6 || $index === 7 ? '%' : ''}}
                      </div>
                    </td>
                  }
                </tr>
                @if (zona.expandido) {
                  @for (suc of zona.sucursales; track suc.code) {
                    <tr class="w3-table-trtd">
                      <td class="w3-center borderAllLow">
                        <mat-icon class="iconoMen" (click)="expandirAsesores(suc)">{{suc.asesoresExpandido?'expand_less':'expand_more'}}</mat-icon>
                      </td>
                      <td class="borderAllLow celdaNombrePl25" [class.w3-text-orange]="suc.asesoresExpandido">{{suc.name}}</td>
                      @for (valor of suc.datos; track $index) {
                        <td class="w3-right-align borderAllLow">
                          <div class="marginDer celdaAltura" [ngClass]="getIndicatorClassCol(valor, $index)">
                            {{valor | formaterNumber:decimalesCol($index):',':'.'}}{{$index === 2 || $index === 5 || $index === 6 || $index === 7 ? '%' : ''}}
                          </div>
                        </td>
                      }
                    </tr>
                    @if (suc.asesoresExpandido) {
                      @if (suc.cargandoAsesores) {
                        <tr class="w3-table-trtd filaAsesor">
                          <td class="w3-center borderAllLow"></td>
                          <td class="borderAllLow celdaNombrePl45" colspan="9">{{'acciones.cargando' | translate}}</td>
                        </tr>
                      }
                      @for (ase of suc.asesores; track ase.code) {
                        <tr class="w3-table-trtd filaAsesor">
                          <td class="w3-center borderAllLow"></td>
                          <td class="borderAllLow celdaNombrePl45">{{ase.name}}</td>
                          @for (valor of ase.datos; track $index) {
                            <td class="w3-right-align borderAllLow">
                              <div class="marginDer celdaAltura" [ngClass]="valor === null ? '' : getIndicatorClassCol(valor, $index)">
                                {{valor === null ? '-' : (valor | formaterNumber:decimalesCol($index):',':'.')}}{{valor !== null && ($index === 2 || $index === 5 || $index === 6 || $index === 7) ? '%' : ''}}
                              </div>
                            </td>
                          }
                        </tr>
                      }
                    }
                  }
                }
              }
            }
            <tr class="w3-table-trtd filaTotal">
              <td class="w3-center borderAllLow"></td>
              <td class="borderAllLow celdaNombrePl10">{{'acciones.total' | translate}}</td>
              @for (valor of totalGeneral; track $index) {
                <td class="w3-right-align borderAllLow">
                  <div class="marginDer celdaAltura" [ngClass]="getIndicatorClassCol(valor, $index)">
                    {{valor | formaterNumber:decimalesCol($index):',':'.'}}{{$index === 2 || $index === 5 || $index === 6 || $index === 7 ? '%' : ''}}
                  </div>
                </td>
              }
            </tr>
          </tbody>
        </table>
      </div>
      }@else{
      <div class="zonaGraficasDual">
        <div class="columnaGrafica">
          <div class="headerGrafica">
            <div class="w3-titulo-contenidomenuSC">
              {{'comercial.asosiatividad.metas.encabezado' | translate}} | {{perspective1}} |
              {{ nivelGrafica() }}{{ getPeriodoCorto() ? ' · ' + getPeriodoCorto() : '' }}
            </div>
            <div class="icons-container">
              <mat-icon class="iconoMen" (click)="etiquetasShowSaldos = !etiquetasShowSaldos">{{etiquetasShowSaldos ? 'label_off' : 'label'}}</mat-icon>
              <mat-icon class="iconoMen" (click)="modalSaldos = true">zoom_out_map</mat-icon>
              <mat-icon class="iconoMen" [matMenuTriggerFor]="menuSaldos">more_vert</mat-icon>
            </div>
            <mat-menu #menuSaldos="matMenu">
              <button mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="menuGraficaSaldos">
                <mat-icon class="iconoGris">insert_chart</mat-icon>
                <span>{{'menu.graficas' | translate}}</span>
              </button>
              <button mat-menu-item class="w3-caja-menu" (click)="viewTabla = true">
                <mat-icon class="iconoGris">table_chart</mat-icon>
                <span>{{'graf.tabla' | translate}}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item class="w3-caja-menu" (click)="exportImageSaldos()">
                <mat-icon class="iconoGris">image</mat-icon>
                <span>{{'acciones.exportar' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #menuGraficaSaldos="matMenu">
              <button mat-menu-item class="w3-caja-menu" (click)="changeGraph('saldos', types.COMBO)" [disabled]="chartTypeSaldos === types.COMBO">
                <mat-icon class="iconoGris">show_chart</mat-icon>
                <span class="opcionMenuIndent">{{'graf.combinada' | translate}}</span>
              </button>
              <button mat-menu-item class="w3-caja-menu" (click)="changeGraph('saldos', types.AREA)" [disabled]="chartTypeSaldos === types.AREA">
                <mat-icon class="iconoGris">area_chart</mat-icon>
                <span class="opcionMenuIndent">{{'graf.area' | translate}}</span>
              </button>
              <button mat-menu-item class="w3-caja-menu" (click)="changeGraph('saldos', types.LINE)" [disabled]="chartTypeSaldos === types.LINE">
                <mat-icon class="iconoGris">show_chart</mat-icon>
                <span class="opcionMenuIndent">{{'graf.lineal' | translate}}</span>
              </button>
            </mat-menu>
          </div>
          <app-graficador #graficasSaldos class="graficaFlex"
            [type]="chartTypeSaldos"
            [labels]="chartLabelsSaldos"
            [data]="chartDataSaldos"
            [colors]="paletaSaldos"
            [axisY]="chartAxisYSaldos"
            [setTwoLast]="true"
            [axisX]="esNivelAsesorGrafica() ? ('comercial.asosiatividad.metas.titulo-asesores' | translate) : ''"
            [legend]="{ enabled: true, position: 'bottom' }"
            [formatEtiquetas]="true"
            [comboLineaPorcentaje]="true"
            [etiquetas]="etiquetasShowSaldos"
            [zona]="1"
          />
        </div>
        <div class="columnaGrafica">
          <div class="headerGrafica">
            <div class="w3-titulo-contenidomenuSC">
              {{'comercial.asosiatividad.metas.encabezado' | translate}} | {{perspective2}} |
              {{ nivelGrafica() }}{{ getPeriodoCorto() ? ' · ' + getPeriodoCorto() : '' }}
            </div>
            <div class="icons-container">
              <mat-icon class="iconoMen" (click)="etiquetasShowClientes = !etiquetasShowClientes">{{etiquetasShowClientes ? 'label_off' : 'label'}}</mat-icon>
              <mat-icon class="iconoMen" (click)="modalClientes = true">zoom_out_map</mat-icon>
              <mat-icon class="iconoMen" [matMenuTriggerFor]="menuClientes">more_vert</mat-icon>
            </div>
            <mat-menu #menuClientes="matMenu">
              <button mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="menuGraficaClientes">
                <mat-icon class="iconoGris">insert_chart</mat-icon>
                <span>{{'menu.graficas' | translate}}</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item class="w3-caja-menu" (click)="exportImageClientes()">
                <mat-icon class="iconoGris">image</mat-icon>
                <span>{{'acciones.exportar' | translate}}</span>
              </button>
            </mat-menu>
            <mat-menu #menuGraficaClientes="matMenu">
              <button mat-menu-item class="w3-caja-menu" (click)="changeGraph('clientes', types.COMBO)" [disabled]="chartTypeClientes === types.COMBO">
                <mat-icon class="iconoGris">show_chart</mat-icon>
                <span class="opcionMenuIndent">{{'graf.combinada' | translate}}</span>
              </button>
              <button mat-menu-item class="w3-caja-menu" (click)="changeGraph('clientes', types.AREA)" [disabled]="chartTypeClientes === types.AREA">
                <mat-icon class="iconoGris">area_chart</mat-icon>
                <span class="opcionMenuIndent">{{'graf.area' | translate}}</span>
              </button>
              <button mat-menu-item class="w3-caja-menu" (click)="changeGraph('clientes', types.LINE)" [disabled]="chartTypeClientes === types.LINE">
                <mat-icon class="iconoGris">show_chart</mat-icon>
                <span class="opcionMenuIndent">{{'graf.lineal' | translate}}</span>
              </button>
            </mat-menu>
          </div>
          <app-graficador #graficasClientes class="graficaFlex"
            [type]="chartTypeClientes"
            [labels]="chartLabelsClientes"
            [data]="chartDataClientes"
            [colors]="paletaClientes"
            [axisY]="chartAxisYClientes"
            [setTwoLast]="true"
            [axisX]="esNivelAsesorGrafica() ? ('comercial.asosiatividad.metas.titulo-asesores' | translate) : ''"
            [legend]="{ enabled: true, position: 'bottom' }"
            [formatEtiquetas]="true"
            [comboLineaPorcentaje]="true"
            [etiquetas]="etiquetasShowClientes"
            [zona]="2"
          />
        </div>
      </div>
      }
    </div>
    <div class="tarjetsZone">
      @for (tar of tarjets; track $index) {
      <div class="zonaTarjets">
        <app-tarjetas [header]="tar.header" [valueStr]="tar.valueStr" [footer]="tar.footer"
          [showIcon]="tar.showIcon" [icon]="tar.icon" [iconColor]="tar.iconColor"></app-tarjetas>
      </div>
      }
    </div>
    }@else{
    <div class="tableZone">
      <app-skeleton-table class="graficaCompleta" [columnas]="8" [filas]="16"/>
    </div>
    <div class="tarjetsZone">
      @for (item of tarjetasSkeleton; track $index) {
        <div class="zonaTarjets">
          <app-skeleton-card/>
        </div>
      }
    </div>
    }
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal" (close)="modal = false" [export]="true"
  [iconoExport]="'description'" (exportFile)="exportExcel()">
  <div modal-header>
    <span class="w3-titulo-contenidomenuSC">{{ 'comercial.asosiatividad.metas.encabezado' | translate }}</span>
  </div>
  <div modal-body class="modalAncho">
    <div class="w3-scroll tablaModalScroll">
      <table class="w3-table borderAllLow">
        <thead>
          <tr class="borderEncTop">
            <th class="stikyColumFillWhite2 borderEncRight borderEncLeft w3-center w3-table-title-white stickyFilaUno" colspan="2"></th>
            <th class="stikyColumFillWhite2 borderEncRight w3-center encGrupoFila1 stickyFilaUno" colspan="3">
              {{perspective1}}</th>
            <th class="stikyColumFillWhite2 borderEncRight w3-center encGrupoFila1 stickyFilaUno" colspan="3">{{perspective2}}</th>
            <th class="stikyColumFillWhite2 borderEncRight w3-center encGrupoFila1 stickyFilaUno" colspan="2">
              {{'comercial.asosiatividad.metas.titulo-encabezado-1' | translate}}
            </th>
          </tr>
          <tr class="borderEncTop">
            <th class="borderEncRight borderEncLeft w3-center encZonaAgencias stikyColumFillWhite2 celdaNombrePl10" colspan="2">
              {{'comercial.asosiatividad.metas.titulo-zona-agencias' | translate}}
            </th>
            @for (enc of encabezados; track $index) {
              @if (enc !== 0) {
                <th class="borderEncRight w3-center"
                  [ngClass]="{'w3-table-title stikyColum2': enc>=1 && enc<=3 || enc>=7, 'stikyColumFillLow2 w3-table-titleLow': enc>=4 && enc<=6}"
                  >
                  {{enc === 10 ? ('comercial.asosiatividad.metas.titulo-meta-anual-clientes' | translate) : ('comercial.asosiatividad.metas.titulo-'+(enc+1)+'-tabla' | translate)}}
                </th>
              }
            }
          </tr>
        </thead>
        <tbody>
          @for (zona of zonas; track zona.code) {
            @if (zona.visible) {
              <tr class="w3-table-trtd filaZona">
                <td class="w3-center borderAllLow">
                  <mat-icon class="iconoMen" (click)="expandirElementos(zona)">{{zona.expandido?'expand_less':'expand_more'}}</mat-icon>
                </td>
                <td class="borderAllLow celdaNombrePl10">{{zona.name}}</td>
                @for (valor of zona.datos; track $index) {
                  <td class="w3-right-align borderAllLow">
                    <div class="marginDer celdaAltura" [ngClass]="getIndicatorClassCol(valor, $index)">
                      {{valor | formaterNumber:decimalesCol($index):',':'.'}}{{$index === 2 || $index === 5 || $index === 6 || $index === 7 ? '%' : ''}}
                    </div>
                  </td>
                }
              </tr>
              @if (zona.expandido) {
                @for (suc of zona.sucursales; track suc.code) {
                  <tr class="w3-table-trtd">
                    <td class="w3-center borderAllLow">
                      <mat-icon class="iconoMen" (click)="expandirAsesores(suc)">{{suc.asesoresExpandido?'expand_less':'expand_more'}}</mat-icon>
                    </td>
                    <td class="borderAllLow celdaNombrePl25" [class.w3-text-orange]="suc.asesoresExpandido">{{suc.name}}</td>
                    @for (valor of suc.datos; track $index) {
                      <td class="w3-right-align borderAllLow">
                        <div class="marginDer celdaAltura" [ngClass]="getIndicatorClassCol(valor, $index)">
                          {{valor | formaterNumber:decimalesCol($index):',':'.'}}{{$index === 2 || $index === 5 || $index === 6 || $index === 7 ? '%' : ''}}
                        </div>
                      </td>
                    }
                  </tr>
                  @if (suc.asesoresExpandido) {
                    @if (suc.cargandoAsesores) {
                      <tr class="w3-table-trtd filaAsesor">
                        <td class="w3-center borderAllLow"></td>
                        <td class="borderAllLow celdaNombrePl45" colspan="9">{{'acciones.cargando' | translate}}</td>
                      </tr>
                    }
                    @for (ase of suc.asesores; track ase.code) {
                      <tr class="w3-table-trtd filaAsesor">
                        <td class="w3-center borderAllLow"></td>
                        <td class="borderAllLow celdaNombrePl45">{{ase.name}}</td>
                        @for (valor of ase.datos; track $index) {
                          <td class="w3-right-align borderAllLow">
                            <div class="marginDer celdaAltura" [ngClass]="valor === null ? '' : getIndicatorClassCol(valor, $index)">
                              {{valor === null ? '-' : (valor | formaterNumber:decimalesCol($index):',':'.')}}{{valor !== null && ($index === 2 || $index === 5 || $index === 6 || $index === 7) ? '%' : ''}}
                            </div>
                          </td>
                        }
                      </tr>
                    }
                  }
                }
              }
            }
          }
          <tr class="w3-table-trtd filaTotal">
            <td class="w3-center borderAllLow"></td>
            <td class="borderAllLow celdaNombrePl10">{{'acciones.total' | translate}}</td>
            @for (valor of totalGeneral; track $index) {
              <td class="w3-right-align borderAllLow">
                <div class="marginDer celdaAltura" [ngClass]="getIndicatorClassCol(valor, $index)">
                  {{valor | formaterNumber:decimalesCol($index):',':'.'}}{{$index === 2 || $index === 5 || $index === 6 || $index === 7 ? '%' : ''}}
                </div>
              </td>
            }
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</app-modal>

<app-modal [isOpen]="modalSaldos" (close)="modalSaldos = false" [export]="true" [iconoExport]="'image'" (exportFile)="exportImageSaldos()">
  <div modal-header>
    <span class="w3-titulo-contenidomenuSC">
      {{'comercial.asosiatividad.metas.encabezado' | translate}} | {{perspective1}} |
      {{ nivelGrafica() }}{{ getPeriodoCorto() ? ' · ' + getPeriodoCorto() : '' }}
    </span>
  </div>
  <div modal-body class="modalAncho">
    <div class="modalGraficaAltura">
      @if(modalSaldos){
        <app-graficador class="graficaCompleta"
          [type]="chartTypeSaldos"
          [labels]="chartLabelsSaldos"
          [data]="chartDataSaldos"
          [colors]="paletaSaldos"
          [axisY]="chartAxisYSaldos"
          [setTwoLast]="true"
          [axisX]="esNivelAsesorGrafica() ? ('comercial.asosiatividad.metas.titulo-asesores' | translate) : ''"
          [legend]="{ enabled: true, position: 'bottom' }"
          [formatEtiquetas]="true"
          [comboLineaPorcentaje]="true"
          [etiquetas]="etiquetasShowSaldos"
          [zona]="3"
        />
      }
    </div>
  </div>
</app-modal>

<app-modal [isOpen]="modalClientes" (close)="modalClientes = false" [export]="true" [iconoExport]="'image'" (exportFile)="exportImageClientes()">
  <div modal-header>
    <span class="w3-titulo-contenidomenuSC">
      {{'comercial.asosiatividad.metas.encabezado' | translate}} | {{perspective2}} |
      {{ nivelGrafica() }}{{ getPeriodoCorto() ? ' · ' + getPeriodoCorto() : '' }}
    </span>
  </div>
  <div modal-body class="modalAncho">
    <div class="modalGraficaAltura">
      @if(modalClientes){
        <app-graficador class="graficaCompleta"
          [type]="chartTypeClientes"
          [labels]="chartLabelsClientes"
          [data]="chartDataClientes"
          [colors]="paletaClientes"
          [axisY]="chartAxisYClientes"
          [setTwoLast]="true"
          [axisX]="esNivelAsesorGrafica() ? ('comercial.asosiatividad.metas.titulo-asesores' | translate) : ''"
          [legend]="{ enabled: true, position: 'bottom' }"
          [formatEtiquetas]="true"
          [comboLineaPorcentaje]="true"
          [etiquetas]="etiquetasShowClientes"
          [zona]="4"
        />
      }
    </div>
  </div>
</app-modal>